import * as React from "react";

import type { EvaluationResult } from "../../../../../../../../../server/ad-copy-analytics/simulation/lib/evaluations";
import type { AdCopyTestOnlyConceptKey } from "../../../../../../../../../server/models/ad-copy/concept";
import { AdCopyNormRaw } from "./ad-copy-norm-raw";

const thStyle = {
	width: "152px",
} as const satisfies React.CSSProperties;

type Props<T extends AdCopyTestOnlyConceptKey> = {
	evaluationResult: EvaluationResult<T>;
	targetConceptType: T;
};

const AdCopyNormTableComponent = <T extends AdCopyTestOnlyConceptKey>({
	evaluationResult,
	targetConceptType,
}: Props<T>) => {
	return (
		<table className="result-table norm">
			<thead>
				<tr>
					<th />

					<th colSpan={6}>戦略ターゲットグループ</th>
				</tr>

				<tr>
					<th />

					<th style={thStyle}>n数</th>

					<th style={thStyle}>
						購入意向
						<br />
						ワンナンバースコア
					</th>

					<th style={thStyle}>リフト</th>

					<th style={thStyle}>差別性</th>

					<th style={thStyle}>情報検索意向</th>

					<th style={thStyle}>自分向け</th>
				</tr>
			</thead>

			<tbody>
				<AdCopyNormRaw
					//
					evaluationValues={evaluationResult[targetConceptType]}
					targetConcept={targetConceptType}
				/>

				<AdCopyNormRaw
					//
					evaluationValues={evaluationResult.benchMark}
					targetConcept="benchmark"
				/>

				{evaluationResult.currentProduct != null && (
					<AdCopyNormRaw
						//
						evaluationValues={evaluationResult.currentProduct}
						targetConcept="currentProduct"
					/>
				)}
			</tbody>
		</table>
	);
};

export const AdCopyNormTable = React.memo(AdCopyNormTableComponent) as typeof AdCopyNormTableComponent;
